import { Typography } from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';

import { updateRelease } from '../../sources/news';
import { updateReleaseDate, release } from '../queryKeyFactory';

const GetSuccessMessage = ({ date }) => {
  return (
    <Typography>
      <span>Release date set to&nbsp;</span>
      <DateValueFormatter value={date} template={'LL'} />
    </Typography>
  );
};
export const useUpdateReleaseDate = () => {
  const updateMutation = useMutation(updateReleaseDate(), updateRelease, {
    refreshOptions: {
      queryKey: release.all(),
    },
    successMessage: (_, { date }) => {
      return <GetSuccessMessage date={date} />;
    },
  });
  return [updateMutation.mutateAsync, updateMutation];
};
